// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorDescriptionOrganism_wrapper__t6Egu"};